import extendNode from '../extendNode.mjs'
import useCatRootModuleNode from '../_CAT_ROOT_MODULE/useCatRootModuleNode.jsx'
import PropertiesPane from './PropertiesPaneCatRootOm.jsx'
import meta from './metaCatRootOm.mjs'

export default () => {
    const CatRootModuleNode = useCatRootModuleNode()

    return extendNode(CatRootModuleNode, {
        ...meta,
        PropertiesPane,

        canLinkType(map, node, type) {
            return /^(OO)$/.test(type)
        },

        menuItemsInsertConcept(map, node) {
            return [
                {type: 'OO'},
            ]
        },

        menuItemsInsertProduct(map, node) {
            return [
                {type: 'OO'},
            ]
        },
    })
}
